export default function PushInDataLayer(value)
{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(value)
}